import { createContext, useContext } from 'react';

import type { ThemeMode, ThemeSource } from '../../_hooks/useTeamsTheme';

export interface TeamsThemeContextValue {
  mode: ThemeMode;
  source: ThemeSource;
  osTheme: ThemeMode;
  teamsTheme: ThemeMode | null;
  manualTheme: ThemeMode | null;
  isTeamsContext: boolean;
  setManualTheme: (theme: ThemeMode | null) => void;
  resetToAuto: () => void;
  toggleTheme: () => void;
}

export const TeamsThemeContext = createContext<
  TeamsThemeContextValue | undefined
>(undefined);

export const useTeamsThemeContext = (): TeamsThemeContextValue => {
  const context = useContext(TeamsThemeContext);
  if (context === undefined) {
    throw new Error(
      'useTeamsThemeContext must be used within a TeamsThemeRegistry',
    );
  }
  return context;
};
